var EmailAuthenticationLinkAddon = (function ($) {

    var REQUEST_FORM_ID = "email-authentication-link-form";
    var CONFIRM_FORM_ID = "email-authentication-link-confirm-form";
    var TOKEN_INPUT_ID = "email-authentication-link-token";
    var OPEN_BUTTON_SELECTOR = ".email-authentication-link-open";
    var RESEND_NOTE_CLASS = "email-authentication-link-resend-note";
    var RESEND_LINK_CLASS = "email-authentication-link-resend";

    function initializeTrigger() {
        $(document).on("click", OPEN_BUTTON_SELECTOR, function () {
            $(this).hide();
            $(this).siblings(".email-authentication-link-panel").show();
        });
    }

    // Mirrors the click reveal of the request form: the token form is only created once the
    // mail is on its way. Its texts, and those of the resend note seated under the submit
    // button, come from the success paragraph's data attributes.
    function spawnConfirmForm($panel) {
        // One token stage per panel: neither a repeated request submit (the resend link)
        // nor a duplicated script may spawn a second form or note.
        if ($panel.find("#" + CONFIRM_FORM_ID + ", ." + RESEND_NOTE_CLASS).length > 0) {
            return;
        }

        var $success = $panel.find(".email-authentication-link-success");
        var $requestForm = $panel.find("#" + REQUEST_FORM_ID);

        var $form = $("<form>", {
            id: CONFIRM_FORM_ID,
            action: $requestForm.attr("action").replace(/\/request$/, "/confirm"),
            method: "post"
        });
        $form.append($requestForm.children("input[type=hidden]").clone());
        // Attributes are set through .attr() on purpose: the $("<input>", props) builder routes
        // keys that match a $.fn method to that method, and jQuery UI owns $.fn.autocomplete,
        // so "autocomplete" here must not be passed as a builder property.
        var $tokenInput = $("<input>")
            .attr("type", "text")
            .addClass("form-control")
            .attr("id", TOKEN_INPUT_ID)
            .attr("name", "token")
            .attr("autocomplete", "off")
            .attr("placeholder", $success.data("tokenPlaceholder"))
            .attr("aria-label", $success.data("tokenLabel"))
            .attr("required", "required");
        $form.append($("<div>").addClass("form-group").append($tokenInput));
        $form.append($("<button>", {
            type: "submit",
            "class": "pure-button pure-button-primary email-authentication-link-submit"
        }).append($("<span>").text($success.data("tokenSubmit"))));
        $success.after($form);

        // The "did the mail get stuck?" escape hatch, seated under the token form's submit
        // button with its link on its own line, visible from the moment the token stage
        // opens, so waiting never dead-ends: it repeats the request POST in place.
        var $note = $("<p>").addClass(RESEND_NOTE_CLASS + " mb-0");
        $note.append($("<span>").text($.trim($success.data("resendText"))));
        $note.append($("<a>", {
            href: $requestForm.attr("action"),
            "class": RESEND_LINK_CLASS
        }).text($.trim($success.data("resendLink"))));
        $form.after($note);
    }

    // Both transports answer a failure with 4xx/5xx plus a {"message": ...} body holding the
    // translation the server picked — expired, blocked, rate limited — so the panel's single
    // error paragraph shows that specific wording instead of always the generic one. The
    // paragraph's static generic text from the view is stashed on first use and restored
    // whenever the server sent nothing readable (a missing ReD key translates to empty text),
    // so a faceless failure can never inherit a previous, more specific one's wording.
    function reportError($panel, source) {
        var $error = $panel.find(".email-authentication-link-error");
        if (!$error.data("emailAuthenticationLinkFallback")) {
            $error.data("emailAuthenticationLinkFallback", $error.text());
        }
        var payload = (source && source.responseJSON) || source;
        var serverMessage = payload && typeof payload.message === "string" ? payload.message : "";
        $error.text(serverMessage || $error.data("emailAuthenticationLinkFallback"));
        $error.show();
    }

    function initializeRequestForm() {
        $(document).on("submit", "#" + REQUEST_FORM_ID, function (event) {
            event.preventDefault();

            var $form = $(this);
            // Shared guard: it also keeps a quickly retapped resend link from mailing twice.
            if ($form.data("emailAuthenticationLinkPending")) {
                return;
            }
            $form.data("emailAuthenticationLinkPending", true);
            // A previous failure's notice makes way for this attempt's verdict.
            $form.closest(".email-authentication-link-panel").find(".email-authentication-link-error").hide();

            $.ajax({
                url: $form.attr("action"),
                type: "POST",
                data: $form.serialize()
            }).always(function () {
                $form.removeData("emailAuthenticationLinkPending");
            }).done(function () {
                $form.hide();
                var $panel = $form.closest(".email-authentication-link-panel");
                $panel.find(".email-authentication-link-success").show();
                spawnConfirmForm($panel);
                $panel.find("#" + TOKEN_INPUT_ID).trigger("focus");
            }).fail(function (xhr) {
                // The mail did not go out, so the request stays exactly where the customer
                // left it — form and submit button in place, failure notice under them.
                // Whether it was the rate limit or a transport failure is the controller's
                // call; the notice just renders the wording that decision travels with.
                reportError($form.closest(".email-authentication-link-panel"), xhr);
            });
        });
    }

    // The manual token form confirms over XHR, because XHR itself never navigates the browser:
    // success carries the post-sign-in URL. A refusal leaves the stage standing — the error
    // paragraph simply joins it under the resend note — while the explicit header routes the
    // request to the controller's AJAX mapping.
    function initializeConfirmForm() {
        $(document).on("submit", "#" + CONFIRM_FORM_ID, function (event) {
            event.preventDefault();

            var $form = $(this);
            if ($form.data("emailAuthenticationLinkBusy")) {
                return;
            }

            function reportFailure(source) {
                $form.removeData("emailAuthenticationLinkBusy");
                $form.find(".email-authentication-link-submit").prop("disabled", false);
                // The stage the customer is standing on survives a refused token: the error
                // paragraph seats itself under the token form and its resend note, and the
                // next mail's token can be typed straight in.
                reportError($form.closest(".email-authentication-link-panel"), source);
            }

            $form.data("emailAuthenticationLinkBusy", true);
            $form.find(".email-authentication-link-submit").prop("disabled", true);

            $.ajax({
                url: $form.attr("action"),
                type: "POST",
                data: $form.serialize(),
                headers: { "X-Requested-With": "XMLHttpRequest" }
            }).done(function (response) {
                if (response && response.redirect) {
                    window.location.assign(response.redirect);
                    return;
                }
                reportFailure(response);
            }).fail(reportFailure);
        });
    }

    // Tapping resend replays the request POST: it triggers submit on the request form — whose
    // mail is still filled and whose CSRF field is still valid — so the fresh token mail goes
    // out through initializeRequestForm, pending-guard included, and success just refocuses
    // the open token input while failure surfaces the error notice with the server's wording —
    // typically the rate-limit text, since the resend counts toward the very limit it reports.
    function initializeResendLink() {
        $(document).on("click", "." + RESEND_LINK_CLASS, function (event) {
            event.preventDefault();

            $(this).closest(".email-authentication-link-panel")
                .find("#" + REQUEST_FORM_ID)
                .trigger("submit");
        });
    }

    return {
        initializeTrigger: initializeTrigger,
        initializeRequestForm: initializeRequestForm,
        initializeConfirmForm: initializeConfirmForm,
        initializeResendLink: initializeResendLink
    };

})($);

$(function () {
    EmailAuthenticationLinkAddon.initializeTrigger();
    EmailAuthenticationLinkAddon.initializeRequestForm();
    EmailAuthenticationLinkAddon.initializeConfirmForm();
    EmailAuthenticationLinkAddon.initializeResendLink();
});
